import React, { Fragment, Component } from 'react'
import { accessRole } from '../../../../helpers/access_role'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import CustomSelect from'../../../../helpers/ui/CustomSelect'

var reformatOptions = function(raw, label, value) {
    console.log(raw)
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};
var reformatEmployee = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = `${data[label]}` ;
      newObj["value"] = data[value];
  
      return newObj;
    });
};
var reformatPerformance = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = `${data[label]} (${data[value]})` ;
      newObj["value"] = data[value];
  
      return newObj;
    });
};

var userdata = JSON.parse(localStorage.getItem('userdata'));

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            employeeData : {
                employee_name : accessRole('approve') ?'':userdata.employee_name,
                employee_uuid: accessRole('approve') ?'':userdata.employee_uuid,
                employee_nip: accessRole('approve') ?'':userdata.employee_nip,
                employee_position: accessRole('approve') ?'':userdata.employee_current_position_name,
                employee_position_uuid: accessRole('approve') ?'':userdata.employee_current_position_uuid,
                employee_unit_uuid: accessRole('approve') ?'':userdata.employee_current_work_unit_uuid,
                employee_unit_name: accessRole('approve') ?'':userdata.employee_current_work_unit_name,
            },
            employeeOption : [
                {
                    nip : "",
                    nama : ""
                }
            ],
            periodeOption : [
                {
                    period_assess_name : "",
                    period_assess_uuid : ""
                }
            ],
            performanceOption : [
                {
                    period_assess_name : "",
                    performance_code : ""
                }
            ],
            dataStankom : [
                {}
            ]
            
        }
    }

    addLevel = () => {
        let count = this.state.levelComps.length;
        this.setState({
            levelComps: [
                ...this.state.levelComps,
                {
                    name : "",
                    level : count == 0 ? (count+1) : this.state.levelComps.slice(-1)[0].level + 1
                }
            ]
        })

        console.log(this.state.levelComps)
    }

    delLevel = (data) => {
        let count = this.state.levelComps.length-1;
        this.setState({
            levelComps: [
                ...this.state.levelComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatLevel = (raw) => {
        // console.log('raw')
        // console.log(raw)
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = `Level-${data.level_no} ${data.level_name}`;
          newObj["value"] = data.level_uuid;
      
          return newObj;
        });
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.levelComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({levelComps : items});
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 

        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadEmployee = async () => {
        await this.createBloc.fetchEmployee({})
    }
    loadPeriod = async () => {
        await this.createBloc.fetchPeriod({})
    }
    loadPerformance = async () => {
        await this.createBloc.fetchPerformance({})
    }
    handleChangeEmployee = async (e) => {

        const query = {
            nip: e.value
        }
        
        await this.createBloc.fetchDetailEmployee(query)
    }
    loadStankombyPos = async (posuuid) => {

        const query = {
            posuuid: posuuid
        }
        
        await this.createBloc.fetchStankom(query)
    }
    loadlevel = async (competenceuuid, index) => {

        const query = {
            compuuid: competenceuuid,
            index: index
            // type: 1
        }

        // console.log(e.value)
        
        await this.createBloc.fetcLevelCompetence(query)
    }
    componentDidMount() {
        if(!(accessRole('approve'))){
            this.loadStankombyPos(this.state.employeeData.employee_position_uuid)
        }else{

        }
        // console.log(userdata)
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data Employee
        this.loadEmployee()
        this.createBloc.empChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            employeeOption: reformatEmployee(
                                response, 
                                `employee_full_name`,
                                'employee_nip'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.loadPeriod()
        this.createBloc.periodChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        
                        this.setState({
                            periodeOption: reformatOptions(
                                response, 
                                `period_assess_name`,
                                'period_assess_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.loadPerformance()
        this.createBloc.performanceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        
                        this.setState({
                            performanceOption: reformatPerformance(
                                response, 
                                `performance_name`,
                                'performance_code'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.detailempChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    let msg = result.data.message;
                    console.log(resp)
                    this.setState({
                        employeeData : {
                            ...this.state.employeeData,
                            employee_name: resp.employee_full_name,
                            employee_uuid: resp.employee_uuid,
                            employee_nip: resp.employee_nip,
                            employee_position: resp.employee_current_position_name,
                            employee_position_uuid: resp.employee_current_position_uuid,
                            employee_unit_uuid : resp.employee_current_work_unit_uuid,
                            employee_unit_name : resp.employee_current_work_unit_name
                        }
                    })
                    this.loadStankombyPos(resp.employee_current_position_uuid)
                   
                        
                break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.stankomChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    let msg = result.data.message;
                    
                    this.setState({dataStankom:resp})
                    resp.map( (data, index) => {
                        this.loadlevel(data.competence_uuid, index)
                    });   
                break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.levelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    let msg = result.data.message;
                    
                    console.log('level')
                    console.log(resp)
                    
                    this.setState({
                        ["kompetensilevel"+msg.index] : this.reformatLevel(resp)
                    })
                        
                break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Tambah Data Assesment</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Tambah data Manajerial 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                            
                                            {  accessRole('approve') ?
                                                <Row className="mb-3">
                                                    <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Pegawai </Label>
                                                    <Col md="6">
                                                        <CustomSelect 
                                                                name="employee_nip"
                                                                errorMessage="Pilih Pegawai"
                                                                options={this.state.employeeOption} 
                                                                placeholder="Pilih Pegawai"
                                                                onChange={(e) => {
                                                                    this.handleChangeEmployee(e)
                                                                }}
                                                                // defaultValue={this.state.dataForm.optionCategories}
                                                        />
                                                        <AvField
                                                            name="assessment_status"
                                                            type="hidden"
                                                            id="tipe"
                                                            value="1"
                                                        />
                                                    </Col>
                                                </Row>
                                                    : 
                                                    <>
                                                    <Row className="mb-3">
                                                        <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Pegawai </Label>
                                                        <Col md="6">
                                                            <AvField
                                                                name="employee_name_text"
                                                                type="text"
                                                                errorMessage="Masukkan Nama Kamus Kompetensi"
                                                                className="form-control"
                                                                validate={{ required: { value: true } }}
                                                                id="fieldTitle"
                                                                disabled={true}
                                                                value={this.state.employeeData.employee_nip+'-'+this.state.employeeData.employee_name}
                                                            />
                                                            <AvField
                                                                name="assessment_status"
                                                                type="hidden"
                                                                id="tipe"
                                                                value="0"
                                                            />
                                                            <AvField
                                                                name="employee_nip"
                                                                type="hidden"
                                                                id="tipe"
                                                                value={this.state.employeeData.employee_nip}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    
                                                    </>
                                            }
                                                    <Row className="mb-3">
                                                        <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Jabatan </Label>
                                                        <Col md="6">
                                                            <AvField
                                                                name="employee_position_text"
                                                                type="text"
                                                                errorMessage="Masukkan Nama Kamus Kompetensi"
                                                                className="form-control"
                                                                validate={{ required: { value: true } }}
                                                                id="fieldTitle"
                                                                readonly="readonly"
                                                                value={this.state.employeeData.employee_position}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Unit Kerja </Label>
                                                        <Col md="6">
                                                            <AvField
                                                                name="employee_boss_text"
                                                                type="textarea"
                                                                errorMessage="Masukkan Atasan Langsung"
                                                                className="form-control"
                                                                // validate={{ required: { value: true } }}
                                                                id="fieldTitle"
                                                                readonly="readonly"
                                                                value={this.state.employeeData.employee_unit_name}
                                                            />
                                                        </Col>
                                                    </Row>
                                                        
                                                    <AvField
                                                        name="assessment_emp_nip"
                                                        type="hidden"
                                                        value={this.state.employeeData.employee_nip}
                                                    />
                                                    <AvField
                                                        name="assessment_emp_position_uuid"
                                                        type="hidden"
                                                        value={this.state.employeeData.employee_position_uuid}
                                                    />
                                                    <AvField
                                                        name="assessment_emp_unit_uuid"
                                                        type="hidden"
                                                        value={this.state.employeeData.employee_unit_uuid}
                                                    />
                                        
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Periode </Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                        name="assessment_period_uuid"
                                                        errorMessage="Pilih Periode"
                                                        options={this.state.periodeOption} 
                                                        placeholder="Pilih Periode"
                                                        // defaultValue={this.state.dataForm.optionCategories}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            <i>Tanggal Assesment</i><span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="assessment_date"
                                                    placeholder="Tanggal Assesment..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Assesment"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assessment_date"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tujuan<span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="assessment_goal"
                                                    placeholder="Tujuan..."
                                                    type="text"
                                                    errorMessage="Masukkan Tujuan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assessment_goal"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Assesor<span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="assessment_assessor_name"
                                                    placeholder="Assesor..."
                                                    type="text"
                                                    errorMessage="Masukkan Assesor"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="assessment_assessor_name"
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-6">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Hasil Kompetensi<span className="text-danger">*</span></Label>
                                            <Col md="9">

                                            <table className="table">
                                                <thead style={{background:"lavender"}}>
                                                    {
                                                        this.state.dataStankom.map((data, index) => {
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <th style={{width:"25%"}}>
                                                                            {(data.competence_name!=undefined)?(index+1)+'. '+data.competence_name:'-'}
                                                                            <AvField
                                                                                name={`competence_uuid[${index}]`}
                                                                                type="hidden"
                                                                                value={data.competence_uuid}
                                                                            />
                                                                        </th>
                                                                        <th>
                                                                        <CustomSelect 
                                                                            name={`kompetensilevel[${index}]`}
                                                                            errorMessage="Pilih Level"
                                                                            options={this.state["kompetensilevel" + index]} 
                                                                            placeholder="Pilih Level"
                                                                            defaultValue={data.level}
                                                                        />
                                                                        </th>
                                                                    </tr>
                                                                </>  
                                                            )
                                                        })
                                                    }
                                                </thead>
                                            </table>

                                                
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Kinerja Pegawai </Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                        name="assessment_performance"
                                                        errorMessage="Pilih Kinerja Pegawai"
                                                        options={this.state.performanceOption} 
                                                        placeholder="Pilih Kinerja Pegawai"
                                                        // defaultValue={this.state.dataForm.optionCategories}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/assesment/manajerial.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/assesment/manajerial.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView